var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVegaLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "91px",
    viewBox: "0 0 82 91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "White Watermark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.06 0.095 36.32 0.095 36.32 60.382 0.06 60.382"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "White-Watermark",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-1",
    fill: "#FFFFFF",
    points: "47.257 53.458 47.257 42.085 36.32 60.238 18.16 30.095 36.32 90.382 47.443 53.458 47.257 53.458"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-7",
    fill: "#FFFFFF",
    points: "36.32 90.382 58.565 53.458 47.443 53.458 36.32 90.382"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(0.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-11",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "0 0.095 36.32 60.382 18.16 0.095 0 0.095"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-14",
    fill: "#FFFFFF",
    points: "54.95 34.859 49.96 34.859 66.178 50.807 66.178 34.859 54.95 34.859"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-15",
    fill: "#FFFFFF",
    points: "49.96 34.859 49.96 50.807 66.178 50.807 49.96 34.859"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-16",
    fill: "#FFFFFF",
    points: "73.519 17.028 81.465 24.839 81.465 17.028 73.519 17.028"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-17",
    fill: "#FFFFFF",
    points: "73.519 24.839 81.465 24.839 73.519 17.028 73.519 24.839"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-18",
    fill: "#FFFFFF",
    points: "79.225 7.60280727e-13 71.281 7.60280727e-13 79.225 7.811 79.225 7.60280727e-13"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-19",
    fill: "#FFFFFF",
    points: "71.281 7.60280727e-13 71.281 7.811 79.225 7.811 71.281 7.60280727e-13"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-20",
    fill: "#FFFFFF",
    points: "66.429 3.905 56.012 3.905 56.012 3.909 66.429 14.154 66.429 3.905"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-21",
    fill: "#FFFFFF",
    points: "56.012 3.909 56.012 14.154 66.429 14.154 56.012 3.909"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-22",
    fill: "#FFFFFF",
    points: "65.546 29.478 65.546 20.726 56.643 20.726 65.546 29.478"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-23",
    fill: "#FFFFFF",
    points: "56.643 29.478 65.546 29.478 56.643 20.726 56.643 29.478"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-24",
    fill: "#FFFFFF",
    points: "48.494 12.42 34.98 12.42 48.494 25.71 48.494 12.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-25",
    fill: "#FFFFFF",
    points: "34.98 12.42 34.978 12.419 34.978 25.71 48.494 25.71 34.98 12.42"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegaLogoWhite);
export default __webpack_public_path__ + "static/media/vega-logo-white.3fa480eec2e9b835925d759abb2b2918.svg";
export { ForwardRef as ReactComponent };